import React from 'react';
import FlowerImage1 from '../imgs/flower1.jpg';
import FlowerImage2 from '../imgs/flower2.jpg';
import FoodImg1 from '../imgs/food1.jpg';
import FoodImg2 from '../imgs/food2.jpg';
import FoodImg3 from '../imgs/food3.jpg';

const Philosophy: React.FC = () => {
  return (
    <div className="min-h-screen bg-lighttan flex flex-col font-barlow">
        <div className="relative bg-tantext pb-24 flex items-center">
            <div className="text-center max-w-6xl mx-auto px-4">
            <h1 className="text-5xl font-bold text-darkgreentext mt-36 mb-4 leading-relaxed">
                OUR PHILOSOPHY
            </h1>
            <h2 className="text-2xl font-bold text-darkgreentext mt-16 mb-8 leading-relaxed">
                I’ve always been in love with the number 8, so I wanted to base my wellness coaching on 8 principles 
                centered on Love, breath, nature, focus, movement, connection, exchange, and nourishment. Part of my fascination 
                with the number 8 is that on its side, it is infinity. A friend suggested that I don’t have to be limited 
                to 8 ideas…as Motiv8 Living contains endless pursuit of living life to its fullest!!
            </h2>
            <p className="text-xl text-darkgreentext">
                But I did want to share a few that we will touch on and explore as we continue our pursuit of a happy and healthy life!!
            </p>
            </div>
        </div>

        <div className='px-8'>
            <div className="flex flex-col md:flex-row gap-8 mt-24">
                <div className="w-full md:w-1/2">
                    <h2 className="text-4xl font-bold text-darklav mb-4">LOVE</h2>
                    <p className="text-darkgreentext leading-relaxed text-lg">
                        Love is at the center of our philosophy because of the sense of purpose it gives us. Have intention in creating 
                        and fostering loving relationships in your life. Your family, your friends, your passion, your purpose!! This 
                        is what you take into your practice…..this is what you take into HOW you live your life.
                    </p>
                </div>

                <div className="w-full md:w-1/2">
                    <h2 className="text-4xl font-bold text-darklav mb-4">BREATHE</h2>
                    <p className="text-darkgreentext leading-relaxed text-lg">
                        The first thing you do when you are born is take a breath. The last thing you do when you die, is breathe your last.  
                        You breathe whether you think about it or not….take time to focus on breath as a tool and as a sense. Intentional 
                        breathwork can affect your body in significant ways. Explore. Train your autonomic nervous system. Giving you more control 
                        of your stress response system. More balance in your life. Your sense of smell is also connected to your breath. 
                        Be mindful of what you smell and how it affects you.
                    </p>
                </div>
            </div>

            <div className="flex flex-col md:flex-row items-center gap-8 mt-8">
                <div className="w-full md:w-1/2 flex items-center justify-center relative overflow-hidden md:overflow-visible">
                    <img src={FlowerImage1} alt="Flower" className="max-w-xs md:max-w-sm h-auto rotate-90 shadow-lg"/>
                    <div className="absolute inset-0 bg-lighttan opacity-30 rounded-lg"></div>
                </div>

                <div className="w-full md:w-1/2">
                    <h2 className="text-4xl font-bold text-darklav mb-4">NATURE</h2>
                    <p className="text-darkgreentext leading-relaxed mb-2 text-lg">
                        Feel: the cold is your teacher. Your reminder. Snaps you back into your primal form. The heat is your challenge you push 
                        through though always a welcome relief from the cold.
                    </p>
                    <p className="text-darkgreentext leading-relaxed mb-2 text-lg">
                        See: wake to morning light. Go outside. Walk. Look around. See colors coming alive. Take in your environment as you welcome 
                        your day. Find beauty in life. Seek out beauty. Appreciate it. Love it. Find it in the mundane.
                        Ground: connect to the earth, feel it strong beneath you.
                        Marvel at the water, the molecules that have been here for all of earth’s existence..without it, life isn’t possible.
                    </p>
                    <p className="text-darkgreentext leading-relaxed text-lg">
                        Hear: Silence is golden treasure it. Seek to listen to your surroundings. Mindfully. Can you find nature? Can you hear 
                        children? Do you hear evidence of the ingenuity of humans? Music?? Embrace music and focus on vibration, tonality, melody. 
                        Don’t let it be mindless background noise. Lyrics are part of the art. Emotion comes from the performer. What is the message? 
                        Feel it through your hears. Connect to it. Harness it to bolster your intention.
                    </p>
                </div>
            </div>

            
            <div className="text-center mt-16">
                <h2 className="text-4xl font-bold text-darklav mb-4">FOCUS</h2>
                <p className="text-darkgreentext leading-relaxed mx-auto text-lg">
                    The Power of the Human MInd is amazing.  Decide what you want.  Stop making excuses.  Order: having organization and simplicity to 
                    daily life helps build predictive routines.
                </p>
                <p className="text-darkgreentext leading-relaxed mx-auto text-lg">
                    Be Goal oriented. Deciding to work towards something you want…a home, a car, a trip isn’t bad. Just be very clear about what you 
                    want and WHY you want it. Don’t want what you can’t have or aren’t willing to put in the work for. Understand your plan and achieve 
                    it. The object will not benefit you as much as your ability to achieve that which you desire. Never sacrifice the authenticity of 
                    who you are and your pursuit of total happiness for something you “think you need”. Set and achieve goals that matter. That you care 
                    about and feel accomplished (and grateful for) when you achieve them.
                </p>
            </div>

            <div className="flex flex-col md:flex-row gap-8 mt-24">
                <div className="w-full md:w-1/2">
                    <h2 className="text-4xl font-bold text-darklav mb-4">MOVEMENT</h2>
                    <p className="text-darkgreentext leading-relaxed text-lg mb-2">
                        Strength and movement: use your body. Move it. Transport yourself and your consciousness through this world. Use your muscles and 
                        will to move objects, do work, exhibit strength. Intentionally. In all you do. All movement is exercise when done with intention.
                    </p>
                    <p className="text-darkgreentext leading-relaxed text-lg mb-2">
                        Balance: challenge your connection to the earth. Feel gravity. Feel your body compensate for the force. Feel the force. Feel your body.
                    </p>
                    <p className="text-darkgreentext leading-relaxed text-lg">
                        Stretch: position your body where its limits stop your mind from moving it further. Be focused on that point. How does it feel? How does 
                        it fluctuate? Connect your breath and your intention to your movement.
                    </p>
                </div>

                <div className="w-full md:w-1/2">
                    <h2 className="text-4xl font-bold text-darklav mb-4">CONNECTION</h2>
                    <p className="text-darkgreentext leading-relaxed text-lg mb-2">
                        Human beings are incredibly dependent on each other.  We crave connection to each other.  To KNOW each other.  Seek connection.  
                        Seek ways to share who you are and seek to understand and get to know others.  
                    </p>
                    <p className="text-darkgreentext leading-relaxed text-lg mb-2">
                        We also deserve to be connected to ourselves.  Mind/body connection is of incredible importance.  Understand how your mind 
                        impacts your body and how your body impacts your mind.  Take the time and be intentional about exploring how to understand and 
                        listen.
                    </p>
                    <p className="text-darkgreentext leading-relaxed text-lg">
                        We also need to connect to nature.  Kind of repetitive I guess but don’t just “go out into nature”  seek to understand it and 
                        how it interfaces with your being.
                    </p>
                </div>
            </div>

            <div className="flex flex-col md:flex-row items-center gap-8 mt-8">
                <div className="w-full md:w-1/2">
                    <h2 className="text-4xl font-bold text-darklav mb-4">EXCHANGE</h2>
                    <p className="text-darkgreentext leading-relaxed mb-2 text-lg">
                        We live in a world that we depend on each other.  We work, we do a job that allows us to exchange with other humans 
                        for the things we need or want in our life.  Very few people can truly live absent this cooperation.  We also experience 
                        immense benefit from the humans who lived before us, the discoveries they made, and the humans that passed those 
                        discoveries onto us.
                    </p>
                    <p className="text-darkgreentext leading-relaxed text-lg">
                        Gratitude: always being conscious of your blessings helps stay grounded and focused on what you have vs what you don’t.
                    </p>
                    <p className="text-darkgreentext leading-relaxed text-lg">
                        It’s OK to understand what you want.  Be willing to work for it.  Set your goals and understand that it is an exchange 
                        to get what you want.
                    </p>
                </div>
                <div className="w-full md:w-1/2 flex items-center justify-center relative overflow-hidden md:overflow-visible">
                    <img src={FlowerImage2} alt="Flower" className="max-w-xs md:max-w-sm h-auto rotate-90 shadow-lg"/>
                    <div className="absolute inset-0 bg-lighttan opacity-30 rounded-lg"></div>
                </div>
            </div>

            <div className="text-center mt-16 mb-8">
                <h2 className="text-4xl font-bold text-darklav mb-4">NOURISHMENT</h2>
                <p className="text-darkgreentext leading-relaxed mx-auto text-lg">
                    Food has more impact on our well being but is incredibly difficult to study because there are SO MANY OPTIONS.
                </p>
                <p className="text-darkgreentext leading-relaxed mx-auto text-lg">
                    Fasting is important. Stay focused on NOT filling your mouth with food. Wait. Smell. Want. Desire. Control.
                </p>
                <p className="text-darkgreentext leading-relaxed mx-auto text-lg">
                    When it’s time. Be selective. Be mindful. Choose something wonderful. Eating the right food. Whole. Real.
                </p>
                <p className="text-darkgreentext leading-relaxed mx-auto text-lg">
                    There is no perfect diet.  Each person reacts to different foods in different ways.  And different combinations of food 
                    potentially have different effects.
                </p>
                <p className="text-darkgreentext leading-relaxed mx-auto text-lg">
                    YOU are the scientist.  Be mindful of what you eat and how it makes you FEEL.  Practice elimination diets if you have issues 
                    that are difficult to determine how food might play a factor.
                </p>
                <p className="text-darkgreentext leading-relaxed mx-auto text-lg mt-4">
                    I practice an Anti inflammatory diet. No processed food. No food that sits on shelves or storage warehouses and doesn’t go 
                    bad. Eat food that is alive to feel alive. I avoid sugar, wheat, dairy, red meats, seed oils, and alcohol.
                </p>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 px-4 mb-24">
                <div className="relative w-full h-72 overflow-hidden shadow-lg">
                    <img src={FoodImg1} alt="Food 1" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-lighttan bg-opacity-20"></div>
                </div>
                <div className="relative w-full h-72 overflow-hidden shadow-lg">
                    <img src={FoodImg2} alt="Food 2" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-lighttan bg-opacity-20"></div>
                </div>
                <div className="relative w-full h-72 overflow-hidden shadow-lg">
                    <img src={FoodImg3} alt="Food 3" className="w-full h-full object-cover" />
                    <div className="absolute inset-0 bg-lighttan bg-opacity-20"></div>
                </div>
            </div>
        </div>
    </div>
  );
};

export default Philosophy;
